import { useEffect, useState } from "react";

import { Card, CardContent, Divider, Icon, Label, Statistic } from "semantic-ui-react";

import { DistributorService, HelperService } from "../../services";
import { LoadingSpinner, ErrorMessage, NoData, DailyReportCollapsible } from "../../components";
import { FeedbackMessage } from "../../constants";


export function DistributorReportsPage() {

    const [dailyReports, setDailyReports] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<boolean>(false)

    useEffect(() => {
        getAllMyDailyReports()
    }, [])

    const getAllMyDailyReports = async () => {

        try {
            const result = await DistributorService.getAllMyDailyReports()

            setDailyReports(result)

        } catch (error) {

            setError(true)

        } finally {

            setLoading(false)
        }
    }

    const getServiceNames = (report: any): string[] => Array.from(new Set([
        ...Object.keys(report.opening_balances || {}),
        ...Object.keys(report.closing_balances || {}),
    ]))

    return <div>
        <h2 className="mb-30">Rapports</h2>

        {loading && <LoadingSpinner />}

        {error && <ErrorMessage errorText={FeedbackMessage.CASHIER_GET_DR_ERROR} />}

        {!loading && !error && dailyReports.length === 0 && <NoData>Aucun rapport journalier pour le moment</NoData>}

        {!loading && !error && dailyReports.map(report => {

            const serviceNames = getServiceNames(report)

            return <Card fluid key={report.id} className="mb-20 radius-8">
                <CardContent>
                    <div className="flex space-between vertical-center">
                        <div>
                            <strong className="size-17">Rapport #{report.id}</strong>
                            <br />
                            <small>
                                {HelperService.formatDateTime(report.open_at)}
                                {' → '}
                                {report.closed_at ? HelperService.formatDateTime(report.closed_at) : 'en cours'}
                            </small>
                        </div>
                        <Label color={report.state?.toLowerCase() === 'closed' ? 'green' : 'orange'}>{report.state}</Label>
                    </div>

                    <Divider />

                    <div className="flex space-between">
                        <Statistic size="mini">
                            <Statistic.Value>{HelperService.formatAmount(HelperService.sumRecordValues(report.opening_balances))}</Statistic.Value>
                            <Statistic.Label>Solde ouverture</Statistic.Label>
                        </Statistic>
                        <Statistic size="mini">
                            <Statistic.Value>{HelperService.formatAmount(HelperService.sumRecordValues(report.closing_balances))}</Statistic.Value>
                            <Statistic.Label>Solde clôture</Statistic.Label>
                        </Statistic>
                    </div>

                    {/* {(report.opening_comment || report.closing_comment) && <>
                        <Divider />
                        {report.opening_comment && <p><Icon name="pencil" /> Ouverture : {report.opening_comment}</p>}
                        {report.closing_comment && <p><Icon name="pencil" /> Clôture : {report.closing_comment}</p>}
                    </>} */}

                    {serviceNames.length > 0 && <>
                        <Divider />
                        <DailyReportCollapsible title="Détail par service">
                            {serviceNames.map(serviceName => {

                                const details: string[] = []

                                if (report.opening_balances?.[serviceName] !== undefined)
                                    details.push(`Ouverture : ${HelperService.formatAmount(report.opening_balances[serviceName])} Fcfa`)

                                if (report.closing_balances?.[serviceName] !== undefined)
                                    details.push(`Clôture : ${HelperService.formatAmount(report.closing_balances[serviceName])} Fcfa`)

                                return <div className="flex space-between mb-10" key={serviceName}>
                                    <span className="text-bold">{serviceName}</span>
                                    <span>{details.join(' · ')}</span>
                                </div>
                            })}
                        </DailyReportCollapsible>
                    </>}
                </CardContent>
            </Card>
        })}
    </div>
}
